import createIcon from '../../createIcon';

/**
 * @component @name AddCard
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0gzQzEuODkgMyAxLjAxIDMuODkgMS4wMSA1TDEgMTdDMSAxOC4xMSAxLjg5IDE5IDMgMTlIMTNWMTdIM1YxMUgyMVY1QzIxIDMuODkgMjAuMTEgMyAxOSAzWk0xOSA3SDNWNUgxOVY3Wk0yMyAxNlYxOEgyMFYyMUgxOFYxOEgxNVYxNkgxOFYxM0gyMFYxNkgyM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddCard = createIcon('AddCard', [
  [
    'path',
    {
      d: 'M19 3H3C1.89 3 1.01 3.89 1.01 5L1 17C1 18.11 1.89 19 3 19H13V17H3V11H21V5C21 3.89 20.11 3 19 3ZM19 7H3V5H19V7ZM23 16V18H20V21H18V18H15V16H18V13H20V16H23Z',
      key: 'qjjb78',
    },
  ],
]);

export default AddCard;
